/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { HealthReport } from '../models/health-report';
@Injectable({
  providedIn: 'root',
})
class HealthService extends __BaseService {
  static readonly HealthPostPath = '/api/Health/{customer}';
  static readonly HealthHealthPath = '/api/Health/{customer}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `HealthService.HealthPostParams` containing the following parameters:
   *
   * - `value`:
   *
   * - `customer`:
   */
  HealthPostResponse(params: HealthService.HealthPostParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.value;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Health/${encodeURIComponent(String(params.customer))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `HealthService.HealthPostParams` containing the following parameters:
   *
   * - `value`:
   *
   * - `customer`:
   */
  HealthPost(params: HealthService.HealthPostParams): __Observable<Blob> {
    return this.HealthPostResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param customer undefined
   */
  HealthHealthResponse(customer: string): __Observable<__StrictHttpResponse<HealthReport>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Health/${encodeURIComponent(String(customer))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<HealthReport>;
      })
    );
  }
  /**
   * @param customer undefined
   */
  HealthHealth(customer: string): __Observable<HealthReport> {
    return this.HealthHealthResponse(customer).pipe(
      __map(_r => _r.body as HealthReport)
    );
  }
}

module HealthService {

  /**
   * Parameters for HealthPost
   */
  export interface HealthPostParams {
    value: string;
    customer: string;
  }
}

export { HealthService }
